import React, { useState, useEffect } from 'react';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import css from './CreativeIQTrialPanel.css';
import { getUserData } from '../../selectors/user';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../components/foundations/Icon';

const getTrialInfoIndication = trialStartDate => {
    const hasTrialStartedToday = !moment(new Date()).diff(trialStartDate, 'days');
    return {
        className: 'info',
        message: `STATIC.CREATIVE_IQ.${hasTrialStartedToday ? 'FIRST_DAY_TRIAL_INDICATION' : 'TRIAL_INDICATION'}`,
        icon: {
            name: 'ai-line',
            variant: IconVariants.INDIGO,
        },
    };
};

const EXPIRATION_INDICATION = {
    className: 'expired',
    message: 'STATIC.CREATIVE_IQ.TRIAL_EXPIRED_INDICATION',
    icon: {
        name: 'circle-x',
        variant: IconVariants.ERROR,
    },
};

const DISPLAYED_PANEL_ROUTES = [
    '/react/creative-iq',
    '/react/creative-gallery',
    '/react/creative-explore',
    '/react/creative-dashboard',
    '/react/manage-ai-dimensions',
];

function CreativeIQTrialPanel() {
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(true);

    const { trials_config: trialsConfig } = useSelector(state => getUserData(state));

    // Reset visibility when navigating to a different page
    useEffect(() => {
        setIsVisible(true);
    }, [location.pathname]);

    const { start_date: trialStartDate, end_date: trialEndDate } = trialsConfig?.creative_iq || {};

    if (!DISPLAYED_PANEL_ROUTES.includes(location.pathname) || !trialStartDate || !trialEndDate || !isVisible)
        return null;

    const daysLeftForTrial = moment(trialEndDate).diff(new Date(), 'days');

    const { className, message, icon } =
        daysLeftForTrial < 0 ? EXPIRATION_INDICATION : getTrialInfoIndication(trialStartDate);

    const handleClose = () => {
        setIsVisible(false);
    };

    return (
        <div className={classNames(css.container, css[className])}>
            <div className={css.message}>
                <Icon size={IconSizes.MEDIUM} {...icon} />
                <Translate id={message} data={{ daysLeft: daysLeftForTrial + 1 }} />
            </div>
            <Icon type={IconTypes.MINGCUTE} name="close-line" size={IconSizes.MEDIUM} onClick={handleClose} />
        </div>
    );
}

export default CreativeIQTrialPanel;
